import React from 'react';
import { useSpring, animated, config, useTrail } from 'react-spring';
import '../styles/Skills.css';
import { LOCALES, localizeText } from '../utils/localize';

const Skills = ({ locale = LOCALES.KR }) => {
  const L = (text) => localizeText(text, locale);
  const skills = [
    { category: 'Languages', accent: '01', items: ['C/C++', 'Python'] },
    { category: 'Embedded Platforms', accent: '02', items: ['STM32', 'Raspberry Pi', 'Jetson Nano'] },
    { category: 'Robotics & Runtime', accent: '03', items: ['ROS', 'FreeRTOS', 'MQTT'] },
    { category: 'Vision & AI', accent: '04', items: ['OpenCV', 'TensorFlow', 'PyTorch', 'OpenGL'] },
  ];

  const containerSpring = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: config.slow,
  });

  const cardsTrail = useTrail(skills.length, {
    from: { opacity: 0, transform: 'translateY(28px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: config.gentle,
  });

  return (
    <section className="skills" id="skills">
      <animated.div style={containerSpring} className="skills-container">
        <div className="section-header section-header-centered">
          <div>
            <p className="section-eyebrow">My Expertise</p>
            <h2 className="section-title">{L('기술 스택')}</h2>
          </div>
        </div>
        <div className="skills-surface">
          <div className="skills-stage">
            <pre className="skills-code-bg" aria-hidden="true">{`registry["languages"] = { "C/C++", "Python" };
registry["platforms"] = { "STM32", "Raspberry Pi", "Jetson Nano" };
registry["runtime"] = { "ROS", "FreeRTOS", "MQTT" };
registry["vision"] = { "OpenCV", "TensorFlow", "PyTorch", "OpenGL" };`}</pre>
          </div>
          <div className="skills-list">
            {skills.map((skillGroup, index) => (
              <SkillGroup key={skillGroup.category} skillGroup={skillGroup} style={cardsTrail[index]} />
            ))}
          </div>
        </div>
      </animated.div>
    </section>
  );
};

const SkillGroup = ({ skillGroup, style }) => (
  <animated.article style={style} className="skill-lane">
    <div className="skill-lane-meta">
      <span className="skill-accent">{skillGroup.accent}</span>
      <h3 className="skill-category">{skillGroup.category}</h3>
    </div>
    <div className="skill-values">
      {skillGroup.items.map((item) => (
        <span key={item} className="skill-item">
          {item}
        </span>
      ))}
    </div>
  </animated.article>
);

export default Skills;
